export enum TimeoffStatus {
  treated = 'treated',
  pending = 'pending',
  approved = 'approved',
  declined = 'declined',
  expired = 'expired'
}

export enum TimeoffComputedStatus {
  expired = 'expired',
  deleted = 'deleted'
}

export enum TimeoffDurationType {
  morning = 'morning',
  afternoon = 'afternoon',
  full_day = 'full_day'
}

export type RestType =
  | 'weekly_rest'
  | 'temporary_unavailability'
  | 'paid_leave'
  | 'sick_leave'
  | 'unpaid_leave'
  | 'family_event'
  | 'holiday'
  | 'work_accident'
  | 'work_accident_by_day'
  | 'maternity'
  | 'compensatory_rest'
  | 'medical_examination'
  | 'formation'
  | 'unjustified'
  | 'justified'
  | 'suspended'
  | 'occupational_hazard'
  | 'paternity'
  | 'parental_leave'
  | 'disciplinary_suspension'
  | 'technical_unemployment'
  | 'late'
  | 'rtt'
  | 'clothing_compensatory_rest'
  | 'night_compensatory_rest'
  | 'default_rest'
  | 'public_holiday_compensatory'

export type TimeoffSchema = {
  begin_day_part: string
  begins_at: string
  counted_days: number
  created_at: string
  end_day_part: string
  ends_at: string
  id: number
  membership: {
    id: number
    firstname: string
    lastname: string
    user_contract_id: number
    team_id: number
  }
  membership_id: number
  message: string
  permissions: { can_read_paid_leave_forecast: boolean }
  rest_deleted: boolean
  rest_type: RestType
  status: TimeoffStatus
}

export type RestInPeriodSchema = {
  ends_at: string
  rest_type: string
  starts_at: string
  from_timeoff: boolean
}

export type TimeoffInPeriodSchema = Omit<RestInPeriodSchema, 'starts_at'> & {
  begins_at: string
  created_from_plannings: boolean
  status: TimeoffStatus
}

export type LinkedMembershipsSchema = {
  id: number
  firstname: string
  lastname: string
  rests_in_period: RestInPeriodSchema[]
  timeoffs_in_period: TimeoffInPeriodSchema[]
}
